export default "# Contact\n## Reach out on [LinkedIn](https://www.linkedin.com/in/rajvishnu)\n"